
export default class ActionService {
  constructor(QueryParamService, $stateParams, TemplateService, $injector) {
    'ngInject';
    Object.assign(this, { QueryParamService, $stateParams, TemplateService, $injector });
  }

  // Lazy RecordService — avoids circular constructor dependency with ActionService.
  get _rcs() {
    return this.$injector.get('RecordService');
  }

  // True when the template is opened via signed-link flow (not URL action/rids).
  get isSignedTemplate() {
    return this.TemplateService?.template?.signTemplate === true;
  }

  get action() {
    return this.$stateParams.action || this.QueryParamService.getRawParam('action');
  }

  get redirect() {
    return this.QueryParamService.getRawParam('redirect');
  }

  get reload() {
    return this.QueryParamService.getRawParam('reload');
  }

  get retrying() {
    return this.QueryParamService.getRawParam('retrying');
  }

  get isEditableAction() {
    if (this.isSignedTemplate) {
      return !this.isPrinting;
    }
    return ['update', 'submit', undefined].includes(this.action);
  }

  get shouldHaveRecords() {
    if (this.isSignedTemplate) {
      return this.isPrinting
        || this.QueryParamService.getRawParam('providerSignedAccess')?.length > 0
        || this._rcs.isEditableSignedWorkingSession();
    }
    const refs = this.TemplateService?.references?.filter((r) => !r._temp) || [];
    if (!refs.length) return false;
    return ['update', 'print'].includes(this.action);
  }

  get isPrinting() {
    if (this.isSignedTemplate) {
      return this._rcs.isSignedPrintOnlyLinkSession();
    }
    return this.action === 'print';
  }

  get isBackendCall() {
    return typeof navigator !== 'undefined' && navigator.webdriver === true;
  }

  get isSubmit() {
    if (this.isSignedTemplate) {
      if (this.isPrinting) return false;
      return this._rcs.hasAnyRefInSubmitMode();
    }
    return this.action === 'submit';
  }

  get isUpdate() {
    if (this.isSignedTemplate) {
      if (this.isPrinting) return false;
      return !this.isSubmit;
    }
    return this.action === 'update';
  }

  get isNotAForm() {
    return this.TemplateService.fe.isBuilderRoute();
  }

  // Per-ref print mode from signed link targets (mixed links can differ per table).
  isRefPrint(refId) {
    return this._rcs.isRefPrint(refId);
  }

  // Per-ref submit mode — new record insert when target has no rid yet.
  isRefSubmit(refId) {
    return this._rcs.isRefSubmit(refId);
  }

  // Per-ref update mode — existing record loaded by signed link rid.
  isRefUpdate(refId) {
    return this._rcs.isRefUpdate(refId);
  }

  // Per-ref editable mode — false for print-only targets on mixed signed links.
  isRefEditable(refId) {
    return this._rcs.isRefEditable(refId);
  }
}
